/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".happ-list[_ngcontent-%COMP%]:last-child{border-bottom:1px solid rgba(0,0,0,.12)}"];
export { styles as styles };
